import React, { useState } from 'react';

import { useDeleteObserverMutation } from 'src/redux/services/centralApi';
import { type Observer } from 'src/interfaces/entities/observer';
import { DeleteOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { Button, Flex, Modal, Tooltip } from 'antd';

export default function DeleteObserver(
	{
		row,
	}: { row: Observer }
) {
	const [ open, setOpen, ] = useState<boolean>(false);

	const [ deleteObserver, deleteObserverResult, ] = useDeleteObserverMutation();

	return <>
		<Tooltip title='Excluir'>
			<Button
				type="text"
				danger
				icon={<DeleteOutlined />}
				onClick={() => setOpen(true)}
			/>
		</Tooltip>
		<Modal
			centered
			title={'Excluir Observador'}
			open={open}
			onCancel={() => {
				setOpen(false);
				toast.info('Operação cancelada!', { autoClose: 1000, });
			}}
			destroyOnHidden
			okText="Excluir"
			onOk={() => {
				deleteObserver(row.observer_id)
					.unwrap()
					.then(() => {
						toast.success('Observador excluído com sucesso!', {
							autoClose: 1000,
						});
					})
					.catch((err) => {
						if (err?.status && err?.status === 500
							&& err?.data?.frontend_message) {
							toast.error(err?.data?.frontend_message, {
								autoClose: 1000,
							});
						}
					})
					.finally(() => {
						setOpen(false);
					});
			}}
			confirmLoading={deleteObserverResult.isLoading}
		>
			<Flex>
				{`Tem certeza que deseja deletar o observador: ${row.name}`}
			</Flex>
		</Modal>
	</>;
}